import React from 'react';
import './Tagline.css';

const Tagline = () => {
  return (
    <section className="tagline">
      <div className="container">
        <div className="tagline-content">
          <h2 className="tagline-text">
            The Branded Content Agency <span className="gradient-text">At Your Service</span>
          </h2>
        </div>
      </div>
    </section>
  );
};

export default Tagline;

